module.exports = __webpack_public_path__ + "img/stock0.f626132e.png";